/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {
	CCInbox,
	MessageInfo_GetUnread
} from "@app/ir-q-app-common/types/message-api";
import * as React from "react";
import {BaseComponent} from "@intuitionrobotics/thunderstorm/frontend";
import {
	backgroundCell,
	InboxTable
} from "../InboxTable";
import {COLORS} from "@res/colors";
import {DB_Patient} from "@app/app-shared/patient";

type Props = {
	chat: CCInbox | MessageInfo_GetUnread
	onClick: () => void
	isOpen: boolean
	getUnreadMessages: (chatId: string) => number
	recipient: () => DB_Patient
	showUnitId?: boolean
}

export class PatientCell
	extends BaseComponent<Props> {

	render() {
		const chat = this.props.chat;
		const unreadMessages = this.props.getUnreadMessages(chat._id);
		const patient = this.props.recipient();

		let backgroundColor = "transparent";
		if (unreadMessages)
			backgroundColor = "#fffaf0";
		if (this.props.isOpen)
			backgroundColor = COLORS.primary_light_blue;

		let name = `${patient?.name}`;

		if (this.props.showUnitId)
			name += ` - ${patient?.unitId}`

		return <div
			className={`ll_h_c clickable ${backgroundCell(backgroundColor)}`}
			onClick={() => this.props.onClick()}>
			{
				InboxTable.rowStyle(name, unreadMessages > 0
				)
			}
		</div>
	}
}
